import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const productPrinterProofService = {
    getAllProductPrinterProofs,
    updateProductPrinterProofStatus,
    getProductPrinterProof,
    updateProductPrinterProof,
    createProductPrinterProof,
};

const MODULE = {
    PRODUCTPRINTERPROOF: 'rnd-product-printer-proofs',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'ProductPrinterProof') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export async function getAllProductPrinterProofs(filter) {

    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            product: filter.product,
            type: filter.type,
            is_active: filter.isActive
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })

    return await apiHelper(API_URL).get(`/${MODULE.PRODUCTPRINTERPROOF}`, requestOptions)
}


export function updateProductPrinterProofStatus(data) {
    const requestOptions = {
        is_active: data.isActive
    }

    return apiHelper(API_URL).patch(`/${MODULE.PRODUCTPRINTERPROOF}/${data.id}`, requestOptions)
}

export function getProductPrinterProof(id) {
    return apiHelper(API_URL).get(`/${MODULE.PRODUCTPRINTERPROOF}/${id}`)
}

export function updateProductPrinterProof(data) {
    const requestOptions = {
        product_uuid: data.productID,
        remark: data.remark,
        type: data.type,
        date: data.date,
    }
    return apiHelper(API_URL).put(`/${MODULE.PRODUCTPRINTERPROOF}/${data.id}`, requestOptions)
}

export function createProductPrinterProof(data) {
    const requestOptions = {
        product_uuid: data.productID,
        remark: data.remark,
        type: data.type,
        date: data.date,
    }

    return apiHelper(API_URL).post(`/${MODULE.PRODUCTPRINTERPROOF}`, requestOptions)
}